export const iconStyle = {
  display: "inline-block",
  verticalAlign: "middle",
};
